<script setup lang="ts">
withDefaults(defineProps<{ tone?: 'neutral' | 'accent' | 'info' | 'high' | 'success' | 'warning' | 'danger'; small?: boolean }>(), {
  tone: 'neutral',
})
</script>

<template>
  <span class="ui-pill" :class="[`ui-pill--${tone}`, { 'ui-pill--small': small }]"><slot /></span>
</template>

<style scoped>
.ui-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  font-size: var(--type-caption-1-size);
  line-height: var(--type-caption-1-line);
  font-weight: var(--weight-medium);
  letter-spacing: 0;
  white-space: nowrap;
}
.ui-pill :deep(svg) {
  width: 10px;
  height: 10px;
}
.ui-pill--small {
  padding: 1px 6px;
  font-size: var(--type-caption-2-size);
}
.ui-pill--neutral {
  background: var(--tint-neutral-bg);
  color: var(--tint-neutral-fg);
}
/* accent = "in progress" / "medium" across the app: the guide's info blue (a tenant theme repaints it, themeCss). */
.ui-pill--accent,
.ui-pill--info {
  background: var(--tint-info-bg);
  color: var(--tint-info-fg);
}
.ui-pill--high {
  background: var(--tint-high-bg);
  color: var(--tint-high-fg);
}
.ui-pill--success {
  background: var(--tint-success-bg);
  color: var(--tint-success-fg);
}
.ui-pill--warning {
  background: var(--tint-warning-bg);
  color: var(--tint-warning-fg);
}
.ui-pill--danger {
  background: var(--tint-danger-bg);
  color: var(--tint-danger-fg);
}
</style>
